<template>
  <div
    :class="[
      'tw-flex tw-items-center tw-rounded-lg toolbar',
      `toolbar--${mode}`,
    ]"
  >
    <router-link
      v-if="!previewMode && route"
      v-slot="{ navigate }"
      custom
      :to="route"
    >
      <AppButton
        text
        :class="{ 'tw-mr-2': !hideCloseButton }"
        circle
        only-icon
        @click="navigate"
      >
        <AppIcon shape="help" size="20" color="white" />
      </AppButton>
    </router-link>

    <template v-else>
      <AppButton text class="tw-mr-2" circle only-icon>
        <AppIcon shape="help" size="20" color="white" />
      </AppButton>
    </template>

    <div
      v-if="mode === 'default' && !hideCloseButton"
      class="separator tw-bg-white tw-mr-2"
    />

    <AppButton
      v-if="!hideCloseButton"
      text
      only-icon
      circle
      @click="handleClose"
    >
      <AppIcon shape="times" size="24" color="white" />
    </AppButton>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import { RouteLocationRaw, useRouter } from 'vue-router'

import { useDemoModeStore } from '@pc/store/demo'

export default defineComponent({
  props: {
    mode: {
      type: String as PropType<'transparent' | 'default'>,
      default: 'default',
    },

    previewMode: {
      type: Boolean,
      default: false,
    },

    route: {
      type: Object as PropType<RouteLocationRaw>,
    },
  },

  emits: ['close'],

  setup(props) {
    const router = useRouter()
    const demoModeStore = useDemoModeStore()

    const hideCloseButton = computed(() => {
      return !props.previewMode && window.history.length === 1
    })

    const handleClose = () => {
      if (!props.previewMode) {
        router.back()
      }

      if (window.history.length === 1) {
        demoModeStore.updateDemoChatVisibility(false)
      }
    }

    return {
      handleClose,
      hideCloseButton,
    }
  },
})
</script>

<style lang="scss" scoped>
.toolbar {
  &--default {
    background-color: rgba(0, 0, 0, 0.4);
  }

  &--transparent {
    background-color: transparent;
  }
}

.separator {
  height: 30px;
  width: 1px;
}
</style>
